import { useMutation } from '@tanstack/react-query'
import { createClient } from '@/api/supabase'
import { USE_MOCK } from '@/config'
import i18n from '@/utils/i18n'

export interface BroadcastPayload {
  title: string
  body: string
  roles: string[]
  user_ids: string[]
}

export interface BroadcastResult {
  ok: boolean
  broadcast_id: string
  recipients: number
  sent: number
  errors: string[]
}

export function useBroadcast() {
  return useMutation({
    mutationFn: async (payload: BroadcastPayload): Promise<BroadcastResult> => {
      if (USE_MOCK) {
        throw new Error(i18n.t('apiErr.notif.mockBroadcastUnavailable'))
      }
      const supabase = createClient()
      const { data, error } = await supabase.functions.invoke<BroadcastResult>('send-broadcast', {
        body: payload,
      })
      if (error) throw new Error(error.message)
      if (!data?.ok) throw new Error(i18n.t('apiErr.notif.broadcastFailed'))
      return data
    },
  })
}
